import { z } from "zod";
export const CommunityBehaviorTag = z.enum(["sleep", "movement", "food", "stress", "connection"]);
/**
 * Display order and label for each behavior tag, shared by every surface
 * that lets a member pick one when sharing a moment (Slack modal, Teams
 * Adaptive Card). Each caller maps this into its own choices shape (Slack
 * Block Kit's {value, label}, Adaptive Cards' {title, value}) since the two
 * frameworks disagree on field names, but the values, labels, and order
 * live here once.
 */
export const COMMUNITY_BEHAVIOR_TAGS_ORDERED = [
    "connection",
    "food",
    "movement",
    "sleep",
    "stress",
];
export const COMMUNITY_BEHAVIOR_TAG_LABELS = {
    connection: "Connection",
    food: "Food",
    movement: "Movement",
    sleep: "Sleep",
    stress: "Stress management",
};
export const CommunityKudosCategory = z.enum([
    "showing_up",
    "inspiring",
    "made_my_day",
    "team_player",
]);
export const CommunityReactionType = z.enum(["cheer", "inspired", "same_here", "welcome"]);
export const CommunityItemType = z.enum(["moment", "kudos", "milestone"]);
// Item kinds a member can react to. Personal resets take reactions like any
// other feed card; milestones stay system-only, and reports keep the
// narrower moderated set above.
export const CommunityReactableItemType = z.enum(["moment", "kudos", "personal_reset"]);
export const CommunityEventType = z.enum([
    "member_joined",
    "streak_milestone",
    "first_reflection",
    "shared_content",
    "shared_microstep",
    "focus_area_level_up",
    "focus_area_habit_formed",
    "route_milestone",
    "challenge_overtake",
]);
export const CommunityMomentStatus = z.enum([
    "draft",
    "pending_safety",
    "pending_healthos_review",
    "pending_company_review",
    "published",
    "rejected",
    "deleted",
]);
export const CommunityKudosStatus = z.enum([
    "pending_safety",
    "private_delivered",
    "pending_company_review",
    "public_published",
    "retracted",
]);
export const CommunityReportReason = z.enum([
    "health_private_info",
    "harassment_unkind",
    "inappropriate_image",
    "company_policy",
    "other",
]);
/**
 * Union of every status a moment or kudos item may carry. Used to tighten
 * admin shapes that previously accepted an arbitrary string for `status`.
 * Adding a new content type's lifecycle here propagates to admin queues and
 * items automatically.
 */
export const CommunityItemStatus = z.union([CommunityMomentStatus, CommunityKudosStatus]);
//# sourceMappingURL=enums.js.map